import React, { Component } from 'react';

export default class view extends Component {
	constructor(props) {
		super(props)
		this.state = {
			PAError: null
		}
	}
	PACheck = (e) => {
		if (this.props.data.PANumber.length == 11) {
			if (this.props.data.CIN == undefined) {
				this.props.navigate('A2')
			} else {
				if (this.props.data.CallType == 'Dispense') {
					//D3 Check
					fetch(window.location.origin + window.location.pathname + 'D3Check', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
						if (response.status == 200) {
							var result = await response.text();
							this.props.navigate(result);
						} else if (response.status == 225) {
							//JSON Returned
							//D4
							var result = await response.json();
							console.log("YO")
							console.log(result.CaloricUnits);
							this.props.data.CaloricUnits = result.CaloricUnits
							this.props.data.RefillsRequested = result.RefillsRequested
							this.props.data.ExpirationDate = result.ExpirationDate
							this.props.data.ModeOfAdmin = result.ModeOfAdmin
							this.props.data.PA = result.PA
							this.props.data.Enteral = result.Enteral
							console.log(result);
							this.props.navigate('D8');
						} else {
							this.setState({ PAError: 'Unexpected Error Occured.' })
						}
					})
				} else {
					//D2a Check
					//If value from variable CallType = Inquiry, ☑ Are there any records in the PA_INFO table where CIN = value from variable CIN and Expiration_Date is > or = today’s date?
					fetch(window.location.origin + window.location.pathname + 'P2Check', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
						if (response.status == 200) {
							var result = await response.json()
							if (!result) {
								this.props.navigate('P1')
							} else {
								if (this.props.data["Participant Type"] == 'Prescriber') {
									console.log(result)
									if (result.PAList.length == 0) {
										this.props.navigate('P1')
									} else {
										this.props.data.TotalCaloriesPerDay = result.TotalCaloriesPerDay
										this.props.data.TotalCaloriesPerMonth = result.TotalCaloriesPerMonth
										this.props.data.PAList = result.PAList

										this.props.navigate('P2')
									}

								} else if (this.props.data["Participant Type"] == 'Dispenser') {
									if (!result.TotalCaloriesPerDay) {
										this.props.navigate('F2')
									} else {
										this.props.data.TotalCaloriesPerDay = result.TotalCaloriesPerDay
										this.props.data.TotalCaloriesPerMonth = result.TotalCaloriesPerMonth
										this.props.data.PAList = result.PAList

										this.props.navigate('F1')
									}
								}
							}
						} else {
							this.setState({ PACheckerror: await response.text() })
						}
					})
				}
			}
		} else {
			this.setState({ PAError: 'Invalid response.' })
		}
	}
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>Enter the Prior Authorization number written on the prescription:</p>
				<input type="text" value={this.props.data.PANumber} onChange={(e) => { this.props.setData('PANumber', e.currentTarget.value) }} />

				<br />
				{this.state.PAError ? <div className="error">{this.state.PAError}</div> : ''}

				<div className="button" onClick={() => this.PACheck()}>Continue</div>
			</div>
		);
	}
}